/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { ResearchChatControllerDeleteSessionMutationResponse, ResearchChatControllerDeleteSessionPathParams, ResearchChatControllerDeleteSession400, ResearchChatControllerDeleteSession401, ResearchChatControllerDeleteSession403, ResearchChatControllerDeleteSession404, ResearchChatControllerDeleteSession409, ResearchChatControllerDeleteSession500 } from "../types/ResearchChatControllerDeleteSession.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getResearchChatControllerDeleteSessionUrl(sessionId: ResearchChatControllerDeleteSessionPathParams["sessionId"]) {
  const res = { method: 'DELETE', url: `/api/research-chat/${sessionId}` as const }
  return res
}

/**
 * @summary Delete a chat session
 * {@link /api/research-chat/:sessionId}
 */
export async function researchChatControllerDeleteSession(sessionId: ResearchChatControllerDeleteSessionPathParams["sessionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ResearchChatControllerDeleteSessionMutationResponse, ResponseErrorConfig<ResearchChatControllerDeleteSession400 | ResearchChatControllerDeleteSession401 | ResearchChatControllerDeleteSession403 | ResearchChatControllerDeleteSession404 | ResearchChatControllerDeleteSession409 | ResearchChatControllerDeleteSession500>, unknown>({ method : "DELETE", url : getResearchChatControllerDeleteSessionUrl(sessionId).url.toString(), ... requestConfig })
  return res.data
}